import {
  ExclamationCircleFilled,
  MinusOutlined,
  PlusOutlined,
} from "@ant-design/icons";
import { Button, InputNumber, Popover } from "antd";
import Compact from "antd/es/space/Compact";
import { useMemo } from "react";

interface OrderProductCartonInputProps {
  productNo: string;
  quantity: number;
  cartons: number;
  onChange: (productNo: string, cartons: number) => void;
}

export default function ProductCartonInput(
  props: OrderProductCartonInputProps,
) {
  const { productNo, quantity, cartons, onChange } = props;

  const error = useMemo(() => {
    if (isNaN(quantity)) {
      return "Quantity is not a number";
    }
    if (isNaN(cartons)) {
      return "Cartons is not a number";
    }
    if (cartons < 1) {
      return "Cartons must be greater than 0";
    }
    if (cartons > quantity) {
      return "Cartons must be less than quantity";
    }
    if (quantity / cartons !== Math.floor(quantity / cartons)) {
      return "Cartons must divide quantity evenly";
    }
    return null;
  }, [cartons, quantity]);
  return (
    <div className="flex flex-col items-start gap-1">
      <Compact>
        <Button
          icon={<PlusOutlined />}
          onClick={() => {
            onChange(productNo, cartons + 1);
          }}
          size="large"
        />
        <InputNumber
          className="!w-16"
          size="large"
          value={cartons}
          min={1}
          max={quantity}
          controls={false}
          onChange={(value) => {
            if (value != null) {
              onChange(productNo, value);
            }
          }}
        />
        <Button
          size="large"
          icon={<MinusOutlined />}
          onClick={() => {
            onChange(productNo, cartons - 1);
          }}
        />
      </Compact>
      {error && (
        <Popover content={error} trigger="hover" placement="left">
          <div className="flex flex-row items-center gap-1 pl-2">
            <ExclamationCircleFilled className="!text-red-500" />
            <span className="text-sm text-red-500 italic cursor-pointer">
              Error found!
            </span>
          </div>
        </Popover>
      )}
    </div>
  );
}
